// extracted by mini-css-extract-plugin
module.exports = {"ActionsPopup":"ActionsPopup_ActionsPopup__ESyCs","Dots":"ActionsPopup_Dots__2eZXq","Actions":"ActionsPopup_Actions__3Ty3a","Action":"ActionsPopup_Action__2XGeG"};